// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getCountryCode = createAsyncThunk('account/getCountryCode', async () => {
  const response = await axios.get('https://ipinfo.io/json?token=a4caeb5dee960f')
  
  return response.data.country ? response.data.country.toLowerCase() : 'za'
})

export const accountSlice = createSlice({
  name: 'account',
  initialState: {
    companyName: '',
    country: '',
    countryCode: '',
    name: '',
    phoneNumber: '',
    lastName: '',
    type: '',
    website: '',
    languagePreference: 'en'
  },
  reducers: {
    handleRegistration: (state, action) => {
      const { name, lastName } = action.payload
      Object.assign(state, { name, lastName })    
    },
    handleDemographics: (state, action) => {
      state.companyName = action.payload.companyName
      state.country = action.payload.country
      state.countryCode = action.payload.countryCode
      state.phoneNumber = action.payload.phoneNumber
      state.website = action.payload.website
      state.languagePreference = action.payload.languagePreference
    },
    handleType: (state, action) => {
      state.type = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getCountryCode.fulfilled, (state, action) => {
        state.countryCode = action.payload
      })
  }
})

export const { 
  handleType,
  handleRegistration,
  handleDemographics
 } = accountSlice.actions

export default accountSlice.reducer
